import script from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseShapeElement.vue?vue&type=style&index=0&id=b13f8fa8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b13f8fa8"]])

export default __exports__